// extracted by mini-css-extract-plugin
module.exports = {"main":"search_main__ULlt0","input":"search_input__hK_o2"};